module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_06@2x-113ed12521a08617b6d1d997a392d611.jpg";